<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import "./assets/css/varible";
  @import './assets/css/github.css';

  html, body {
    padding: 0;
    margin: 0;
    height: 100%;
    background-color: $background;
  }

  .hljs-keyword {
    color: #d14;
  }

  #app {
    font-family: $font-family;
  }

  a {
    text-decoration: none;
    color: $text;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue